var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcn07InsertCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.666 0c1.289 0 2.335.934 2.335 2.334v28L56 32.666V35H32.667v-2.334h-9.334V35H0v-2.334l7-2.334v-28C7 .934 8.045 0 9.334 0zm0 2.334H9.334v25.665h37.332V2.334zm-27.382 9.498c.555 0 1.01.455 1.01 1.011v3.715c0 .556-.455 1.01-1.01 1.01h-2.727c-.556 0-1.01-.454-1.01-1.01v-3.715c0-.556.454-1.01 1.01-1.01h2.727zm6.72 0c.555 0 1.01.455 1.01 1.011v3.715c0 .556-.455 1.01-1.01 1.01h-2.727c-.556 0-1.011-.454-1.011-1.01v-3.715c0-.556.455-1.01 1.01-1.01h2.727zm6.719 0c.556 0 1.01.455 1.01 1.011v3.715c0 .556-.454 1.01-1.01 1.01h-2.726c-.556 0-1.011-.454-1.011-1.01v-3.715c0-.556.455-1.01 1.01-1.01h2.727zm6.72 0c.556 0 1.01.455 1.01 1.011v3.715c0 .556-.454 1.01-1.01 1.01h-2.727c-.556 0-1.01-.454-1.01-1.01v-3.715c0-.556.454-1.01 1.01-1.01h2.727z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgIcn07InsertCode;